export default __webpack_public_path__ + "static/media/percentage.af37332c.svg";